	Object.defineProperty(exports, "__esModule", {
	    value: true
	});exports.default=window.GrimoireJS.Node.Attribute;


//////////////////
// WEBPACK FOOTER
// ./node_modules/grimoirejs/ref/Node/Attribute.js
// module id = 128
// module chunks = 0